export const setToLocalStorage = (key, value) => {
  if (!key || typeof key !== "string") {
    throw new Error("Invalid key");
  }

  if (typeof value === "object") {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
};

export const parseLocalStorageJSON = (key) => {
  if (!key || typeof key !== "string") {
    throw new Error("Invalid key");
  }
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return localStorage.getItem(key);
  }
};

export const removeFromLocalStorage = () => {
  try {
    localStorage.clear();
  } catch {
    return false;
  }
};

const LOCAL_KEYS = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  USER_DETAILS: "userDetails",
  EXPIRY: "expiry",
};

export default LOCAL_KEYS;

export const downloadBase64AsFile = (base64Data, fileName, mimeType) => {
  try {
    let cleanedBase64 = base64Data.split(",")[1] || base64Data;

    let byteCharacters = atob(cleanedBase64);
    let byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { type: mimeType });
    let a = document.createElement("a");
    let url = URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    // Cleanup the object URL
    URL.revokeObjectURL(url);
  } catch (error) {
  }
};


export const downloadFile = (data) => {
  let url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  let a = document.createElement("a");
  a.href = url;
  a.download = "invoice.pdf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const downloadBufferToExcel = (arrayBuffer, fileName ="invoice.pdf") => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(
    new Blob([arrayBuffer], {
      type: "application/pdf",
    })
  );
  a.download = fileName;
  a.click();
};
export const downloadBase64AsFile1 = (fileName, fileType, fileUrl) => {
  try {
    // Create temporary link element
    const downloadLink = document.createElement("a");
    downloadLink.href = fileUrl;
    downloadLink.download = fileName;
    
    // Add to DOM, trigger click and cleanup
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
 
    // Cleanup URL if it's an object URL
    if (fileUrl.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrl);
    }
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error(`Failed to download file: ${error.message}`);
  }
};